import { ServiceVariables } from './service-variables';

export const MetaTagUtils = {
  setTitle: (title: string, postfix?: string): void => {
    document.title = `${title} — ${postfix ? postfix : ServiceVariables.name}`;
  },
};
